const API_KEY = 'F5995F77-9174-487D-ACA5-4E871A70E595';
export default API_KEY;
